/**
 * Redirect CF7 form to page specified in hidden field "success_redirect"
 */

// document.addEventListener('wpcf7mailsent', (event) => {
//   const formInputs = event.detail.inputs;

//   for (let i = 0; i < formInputs.length; i++) {
//     if ('success_redirect' === formInputs[i].name) {
//       location = document.location.origin + formInputs[i].value;
//     }
//   }
// }, false);

/**
 * Do not require third consent if form subject is != Zgłoszenie naruszenia
 */
document.addEventListener('DOMContentLoaded', ()=> {
  const formSelect = document.querySelector('.wp-block-contact-form-7-contact-form-selector [name="form-subject"]');

  if(formSelect) {
  formSelect.addEventListener('change', (e) => {
    const notificationOfViolationAcceptance = document.querySelectorAll('[data-id="notification-of-violation-acceptance"]');
    notificationOfViolationAcceptance.forEach(item => {
      if (e.target.value !== "Zgłoszenie naruszenia") {
        item.querySelector('.wpcf7-acceptance').classList.add('optional');
      }else {
        item.querySelector('.wpcf7-acceptance').classList.remove('optional');
      }
    });
  })
  }
})